<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import TaskDetailsContent from 'dashboard/components-next/Tasks/TaskDetailsContent.vue';
import TaskDetailsView from 'dashboard/components-next/Tasks/TaskDetailsView.vue';

defineProps({
  task: { type: Object, default: null },
  isUpdating: { type: Boolean, default: false },
  isDeleting: { type: Boolean, default: false },
});

const emit = defineEmits(['toggleStatus', 'updateTask', 'deleteTask']);

const { t } = useI18n();

const dialogRef = ref(null);

const isEditing = ref(false);

const open = () => {
  isEditing.value = false;
  dialogRef.value?.open();
};
const close = () => dialogRef.value?.close();

const handleUpdateTask = updated => {
  isEditing.value = false;
  emit('updateTask', updated);
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :width="isEditing ? 'lg' : 'md'"
    overflow-y-auto
    :title="isEditing ? t('TASKS.DETAILS.TITLE') : ''"
    :show-cancel-button="false"
    :show-confirm-button="false"
  >
    <TaskDetailsView
      v-if="task && !isEditing"
      :task="task"
      :is-deleting="isDeleting"
      @edit="isEditing = true"
      @close="close"
      @toggle-status="emit('toggleStatus')"
      @delete-task="(id, options) => emit('deleteTask', id, options)"
    />
    <TaskDetailsContent
      v-else-if="task"
      :task="task"
      :is-updating="isUpdating"
      :is-deleting="isDeleting"
      class="-mx-6 -mb-6"
      @toggle-status="emit('toggleStatus')"
      @update-task="handleUpdateTask"
      @delete-task="(id, options) => emit('deleteTask', id, options)"
    />
  </Dialog>
</template>
